module.exports = __webpack_public_path__ + "static/media/18ECA31.1ecb7b90.jpg";